require('./site/bootstrap')
require('dragscroll')

import SwiperCore, { Navigation, Lazy } from 'swiper/core'
SwiperCore.use([Navigation, Lazy])

/*/
 * Swiper
/*/
	// const swiperSlideCount = document.querySelectorAll('.swiper-slide').length > 1 ? true : false
	const swiperSlide = new SwiperCore('[sd-slide]', {
		loop: false,
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: false,
		observer: true,
		watchOverflow: true,
		threshold: 5,
		lazy: {
			loadPrevNext: true
		},
		// autoplay: {
		// 	delay: 6000,
		// 	disableOnInteraction: true
		// },
		navigation: {
			prevEl: '.swiper-prev-slide',
			nextEl: '.swiper-next-slide',
			lockClass: 'd-none',
			disabledClass: 'is--disabled'
		},
		breakpoints: {
			1200: {
				spaceBetween: 50,
				slidesPerView: 3
			},
			992: {
				spaceBetween: 30,
				slidesPerView: 3
			},
			576: {
				spaceBetween: 20,
				slidesPerView: 2
			}
		}
	})